import react, { useState, useEffect, useRef } from "react";
import officesittingImg from '../careers/careersImage/unnamed.webp'
import ThinkwikBenefits from "./thinkwikBenefits";
import JobSection from "./JobSection";
import FilteredImages from "./filteredImages ";
import HeadquarterSection from "./HeadquarterSection";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from "react-helmet-async";
import CareerForm from "./careerForm";
import CareerHeroSection from "./CareerHeroSection";

const Careers = () => {
  const [selectedRole, setSelectedRole] = useState('');
  const formRef = useRef(null);

  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Function to be called when Apply Now is clicked
  const handleApplyClick = (role) => {
    setSelectedRole(role);
    // Scroll to form after slight delay (to allow state update/render)
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 200);
  };
  return (
    <>
      <Helmet>
        <title>Career Opportunities | Join Our Team & Grow with Us</title>
        <meta name="description" content="Explore exciting career opportunities with us. Join a dynamic team, grow your skills, and contribute to innovative projects. Your future starts here!" />
        <meta name="keywords" content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services" />
      
            <link rel="canonical" href="https://www.tekitsolution.com/careers" />
           
      </Helmet>
    
      <JobSection setSelectedRole={setSelectedRole} scrollToForm={scrollToForm} />
      <ThinkwikBenefits />
      
      <HeadquarterSection />
      <div ref={formRef}>
        <CareerForm selectedRole={selectedRole} />
      </div>
    </>
  )
}
export default Careers;